import {RoleBasedPermission} from '../../../apiclient/src'
import plannerContactPersonImageSrc from '../assets/ContactPersonImage/planner.jpeg'
import {PLANT_ID} from '../consts'
import type {AppConfig} from '../types'

export const refraplanner: AppConfig = {
  contact: {
    name: 'Daniil Starikov',
    mail: 'daniil.starikov@heidelbergmaterials.com',
    profileImage: plannerContactPersonImageSrc
  },
  name: 'RefraPlanner',
  url: {
    qa: `https://refraplanner-qa.hproduce.digital/plants/${PLANT_ID}`,
    uat: `https://refraplanner-uat.hproduce.digital/plants/${PLANT_ID}`,
    prod: `https://refraplanner.hproduce.digital/plants/${PLANT_ID}`
  },
  whiteListedPermissionTypes: Object.values(RoleBasedPermission)
}
